<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("add") }} {{ $tc("screentype", 1) }}
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  name="screen_type_name"
                  id="screen_type_name"
                  v-validate="'required'"
                  v-model="screen_type_name"
                />
                <label>{{ $tc("screentype", 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t('enterScreenTypeName')" /> -->
              <!-- <img
                src="@/assets/img/icons/question.svg"
                height="20"
                width="20"
                class="ml-2"
                v-b-tooltip.hover
              /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && screen_type_name == ''">
                {{ $tc("pleaseEnterScreenTypeName", 1) }}</span
              >
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="row pb-3">
            <div class="col-md-3 col-xl-2 align-self-center">
              <label class="mb-0">{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10 align-self-center">
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox mb-0 ml-2"
                v-model="screen_type_is_active"
                value="Y"
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button class="btn-blue" @click.prevent.stop="handleSubmit(true)">
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="screen-type"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      screen_type_name: "",
      screen_type_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {
    this.resetHandler();
  },
  methods: {
    resetHandler: function () {
      this.screen_type_name = "";
    },
    handleSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let payload = {
            screen_type_name: this.screen_type_name,
            screen_type_is_active: this.screen_type_is_active,
          };
          MasterService.AddScreenTypes(payload)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                this.$toasted.show(data.message || "Saved Successfully", {
                  type: "success",
                });
                if (flag) {
                  this.$router.push({
                    path: "screen-type",
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                this.$toasted.show(data.message || "Something went wrong", {
                  type: "error",
                });
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              this.$toasted.show(data.error);
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScreenTypeComponent/addScreenType.vue